module.exports = __webpack_public_path__ + "static/media/folder.26373808.svg";